import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    if (title) {
      document.title = `${title}`;
    } else {
      document.title = `Lynora | Social Gaming Entertainment`;
    }
  }, [title]);
};
